import Home from './pages/Home';

function App() {
  return (
    <div className="w-full min-h-screen font-sans">
      <Home />
    </div>
  );
}

export default App;
